import React from "react";
import styled from "styled-components";
import { ISVGProps } from "types";

const Group = styled.g`
    transform-origin: 152px 152px;
    animation: rotate-360 30s linear infinite;
`;

export default function Asterisk(props: ISVGProps) {
    return (
        <svg
            width="465"
            height="545"
            viewBox="0 0 465 545"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Group>
                <rect
                    x="127.465"
                    width="49.0709"
                    height="304"
                    rx="24.5354"
                    fill="var(--color-secondary-highlight)"
                />
                <rect
                    x="304"
                    y="127.465"
                    width="49.0709"
                    height="304"
                    rx="24.5354"
                    transform="rotate(90 304 127.465)"
                    fill="var(--color-secondary-highlight)"
                />
                <rect
                    x="276.828"
                    y="242.131"
                    width="49.0709"
                    height="304"
                    rx="24.5354"
                    transform="rotate(135 276.828 242.131)"
                    fill="var(--color-secondary-highlight)"
                />
                <rect
                    x="32.6328"
                    y="249.248"
                    width="49.0709"
                    height="304"
                    rx="24.5354"
                    transform="rotate(-120 32.6328 249.248)"
                    fill="var(--color-secondary-highlight)"
                />
            </Group>
        </svg>
    );
}
